import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  getClassResponseQuality, getEnterpriseResponseQuality, readableApiError,
} from '../../api/dashboard';
import './dashboard.css';

const LEVEL_LABEL = { high: '较明显存疑', low: '轻度存疑' };
const LEVEL_BADGE = {
  high: { bg: '#fef3c7', fg: '#92400e' },
  low: { bg: '#f1f5f9', fg: '#475569' },
};

// scope-aware（class | enterprise）。后端 gate 到 enterprise_admin+（讲师 403）。
export default function ResponseQualityPage({ scope = 'class' }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const isEnt = scope === 'enterprise';
  const basePath = isEnt ? `/dashboard/enterprises/${id}` : `/dashboard/classes/${id}`;

  useEffect(() => {
    setData(null); setError(null);
    (isEnt ? getEnterpriseResponseQuality(id) : getClassResponseQuality(id))
      .then(setData)
      .catch((err) => setError(readableApiError(err)));
  }, [id, isEnt]);

  if (error) return <div className="aiq-dash dash-page"><div className="dash-card dash-card--error">{error}</div></div>;
  if (!data) return <div className="aiq-dash dash-page"><div className="dash-card">加载中...</div></div>;

  const members = data.members || [];

  return (
    <div className="aiq-dash dash-page">
      <div className="dash-head">
        <h1 className="dash-h1">作答质量</h1>
        <p className="dash-sub">基于作答行为的有效性提示，仅供复核参考，不计入能力评分。</p>
      </div>

      <Link to={basePath} className="dash-back">← 返回总览</Link>

      <div className="dash-card">
        <div className="dash-sec"><h2>作答有效性概览</h2></div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <div className="dash-badge" style={{ padding: '8px 14px', borderRadius: 8, background: '#fef3c7', color: '#92400e' }}>
            存疑 {data.flagged_count ?? 0} 人
          </div>
          <div className="dash-badge" style={{ padding: '8px 14px', borderRadius: 8, background: '#ecfdf5', color: '#0f766e' }}>
            已评估 {data.completed_with_quality ?? 0} 人
          </div>
          <div className="dash-badge" style={{ padding: '8px 14px', borderRadius: 8, background: '#fef2f2', color: '#991b1b' }}>
            存疑占比 {data.water_fill_rate == null ? '—' : `${data.water_fill_rate}%`}
          </div>
        </div>
        {data.missing_quality > 0 && (
          <div className="dash-mut" style={{ marginTop: 12, fontSize: 12 }}>
            另有 {data.missing_quality} 人作答质量待评估，暂未纳入统计。
          </div>
        )}
      </div>

      <div className="dash-card">
        <div className="dash-sec"><h2>建议复核名单</h2></div>
        {members.length === 0 ? (
          <div className="dash-mut">未发现作答有效性存疑的学员。</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8 }}>
            {members.map((m, idx) => {
              const badge = LEVEL_BADGE[m.level] || LEVEL_BADGE.low;
              return (
                <div key={m.student?.id ?? idx} className="dash-risk">
                  <div className="dash-risk__hd">
                    <span className="dash-risk__who">
                      {m.student?.display_name || '—'}
                      {m.student?.position ? `（${m.student.position}）` : ''}
                    </span>
                    <span className="dash-badge" style={{ background: badge.bg, color: badge.fg }}>
                      {LEVEL_LABEL[m.level] || m.level}
                    </span>
                  </div>
                  <div className="dash-risk__bd">{m.text}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
